/**
 * ngEnclodLogo — the EnCLOD project logo (#862) on the modules EnCLOD paid
 * for: the Promet and Kakovost zraka panels of the Nova Gorica map and their
 * report page /ng-report. One function, so every surface (and the public view
 * later) shows the same file under the same rules.
 *
 * The PNG is the file MONG sent (EnCLOD_Logo_Standard_medium.png), byte for
 * byte — never crop, resize or re-encode it. Vite emits it with a content hash
 * in its name, so the one-year immutable /assets cache is safe when it changes.
 *
 * MONG's rule: the EU flag on the logo is larger than any other logo on the
 * page (the King.Prostor mark in the AI button is 28×10 px). The flag is
 * 195×130 px of the 1256×533 logo; the sheet keeps the logo wide enough for
 * that on the narrowest panel, and the flag ≥ 1 cm high in print.
 */

import { styleManager } from '../../../../../utils/StyleManager.js';
import logoUrl from './EnCLOD_Logo_Standard_medium.png';
import styles from './ngEnclodLogo.css?inline';

/** The PNG's own size — reserves the box before the file arrives. */
export const ENCLOD_LOGO_WIDTH = 1256;
export const ENCLOD_LOGO_HEIGHT = 533;
export const ENCLOD_LOGO_ALT = 'Projekt EnCLOD, Interreg Central Europe, sofinancira Evropska unija';

/**
 * The logo markup for the top of a module. The panels load it lazily (they
 * are not on screen at page load); a page that shows it on arrival passes
 * `eager`.
 */
export function enclodLogoHtml({ eager = false }: { eager?: boolean } = {}): string {
  styleManager.injectStyles('ng-enclod-logo-styles', styles);
  return `<div class="ng-enclod"><img class="ng-enclod-img" src="${logoUrl}" width="${ENCLOD_LOGO_WIDTH}" height="${ENCLOD_LOGO_HEIGHT}" alt="${ENCLOD_LOGO_ALT}" loading="${eager ? 'eager' : 'lazy'}" decoding="async" /></div>`;
}
